<template>
    <div id="map-comp"></div>
</template>

<script setup>
import { onMounted, shallowRef, inject } from 'vue';
import L from 'leaflet';

const map = shallowRef(null);
const dataStore = inject('datastore');

onMounted(() => {
    // Rotation code, adapted from:
    // https://github.com/bbecquet/Leaflet.RotatedMarker/blob/master/leaflet.rotatedMarker.js
    //

    // add support for rotating markers
    (function () {
        // Save original method before overwriting it below.
        const _setPosOriginal = L.Marker.prototype._setPos

        L.Marker.addInitHook(function () {
            const anchor = this.options.icon.options.iconAnchor
            this.options.rotationOrigin = anchor ? `${anchor[0]}px ${anchor[1]}px` : 'center center'
        })

        L.Marker.include({
            // _setPos is alled when update() is called, e.g. on setLatLng()
            _setPos: function (pos) {
                _setPosOriginal.call(this, pos)
                if (this.options.rotation) this._rotate()
            },
            _rotate: function () {
                this._icon.style[`${L.DomUtil.TRANSFORM}Origin`] = this.options.rotationOrigin
                this._icon.style[L.DomUtil.TRANSFORM] += ` rotate(${this.options.rotation}deg)`
            }
        })
    })()

    map.value = L.map('map-comp', { preferCanvas: true }).setView([51.505, -0.09], 13);


    const leafletCSS = document.createElement('link');
    leafletCSS.rel = 'stylesheet';
    leafletCSS.href = 'https://unpkg.com/leaflet/dist/leaflet.css';
    document.head.appendChild(leafletCSS);


    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxNativeZoom: 19,
        maxZoom: 22
    }).addTo(map.value);

    dataStore.setMap(map.value);

    // Area selection logic
    let isSelecting = false;
    let startLatLng = null;
    let selectionRectangle = null;

    map.value.on('mousedown', (e) => {
        if (dataStore.isAreaSelectionMode?.value) {
            isSelecting = true;
            startLatLng = e.latlng;
            selectionRectangle = L.rectangle([startLatLng, startLatLng], {
                color: '#367530',
                weight: 1,
                fillOpacity: 0.1
            }).addTo(map.value);
            map.value.dragging.disable();
        }
    });

    map.value.on('mousemove', (e) => {
        if (isSelecting && selectionRectangle) {
            selectionRectangle.setBounds([startLatLng, e.latlng]);
        }
    });

    map.value.on('mouseup', (e) => {
        if (isSelecting) {
            isSelecting = false;
            map.value.dragging.enable();
            const bounds = selectionRectangle.getBounds();
            
            // Trigger the spatial query
            dataStore.handleAreaSelection(bounds);
            
            // Remove the rectangle after a short delay or keep it?
            // For now, let's remove it and show the results
            setTimeout(() => {
                if (selectionRectangle) {
                    map.value.removeLayer(selectionRectangle);
                    selectionRectangle = null;
                }
            }, 1000);
        }
    });
});

</script>

<style>
#map-comp {
    height: 100%;
    width: 100%;
    overflow: hidden;
}
</style>